import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import "./styles.css";
import newsServices from "../../../api/services/newsServices";
import { Eye } from "lucide-react";

const NewsDetail = () => {
  const location = useLocation();
  const [currentNews, setCurrentNews] = useState<INews | null>(null);

  function formatDateString(dateString: string) {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  }

  useEffect(() => {
    const fetchCurrentNews = async () => {
      if (!location.state) {
        return;
      }

      const response = await newsServices.getNewsById(location.state.news.id);

      if (response.error) {
        console.error(response.error);
        return;
      }

      setCurrentNews(response.data);
    };

    fetchCurrentNews();
  }, [location]);

  return (
    <div className="w-full flex justify-center items-center px-2 py-10">
      <div className="w-full max-w-standard flex flex-col justify-center items-center gap-10">
        <div className="w-full flex flex-col justify-center items-center gap-4">
          <p className="text-primary-blue text-center md:text-3xl text-xl font-bold">
            {currentNews?.title}
          </p>

          <div className="border-b-4 border-primary-blue w-20"></div>

          <p className="text-primary-blue text-center text-base">
            {currentNews?.author.name +
              " - " +
              formatDateString(currentNews?.create_date as string)}
          </p>

          <p className="font-bold text-primary-blue">
            <Eye size={24} className="inline-block mr-1" />
            {currentNews?.views}
          </p>
        </div>

        <img
          src={currentNews?.thumbnail}
          alt="thumbnail"
          className="w-full h-[600px] object-cover rounded-xl"
        />

        <p className="w-full text-primary-blue text-justify font-bold italic">
          {currentNews?.subtitle}
        </p>

        {currentNews?.content && (
          <div
            className="w-full blog-content-section"
            dangerouslySetInnerHTML={{ __html: currentNews.content }}
          >
            {/* <p className="w-full text-primary-blue text-justify">
            As of late November, Viet Nam welcomed over 15.8 million
            international visitors. In November only, the number of foreign
            visitors valued 1.7 million, setting a new record height,
            representing a year-on-year increase of nearly 40 percent.
          </p>

          <p className="w-full text-primary-blue text-justify">
            Hence, the tourism industry is expected to welcome 17 million
            foreign guests, materializing the preset goal in 2024.
          </p>

          <p className="w-full text-primary-blue text-justify">
            A large number of enterprises launched effective tourism promotion
            programs to welcome more foreign visitors, higher than during
            post-pandemic period. Especially, some localities fulfilled their
            preset goals from two to three months ahead of schedules namely Da
            Nang, Khanh Hoa, Binh Dinh, Ninh Binh, Ninh Thuan and Thanh Hoa.
          </p> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsDetail;
